var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:("channel_radio_" + _vm.rowId + "_" + _vm.columnId + "_" + _vm.id),staticClass:"channel-radio",class:{ selected: _vm.selected },on:{"click":function($event){return _vm.toggleChannel({
      channelId: _vm.id,
      rowId: _vm.rowId,
      colId: _vm.columnId,
      refs: _vm.$refs,
    })}}},[_c('hr'),_c('div',{class:['radio']}),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }